import React, { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { Swiper, SwiperSlide } from "swiper/react";
import { Mousewheel, Navigation } from "swiper";
import "./activityTypes.css";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/scrollbar";

import ActivityType from "./activityType";
import {
  selectAllActivityTypes,
  deselectAllActivityTypes,
  toggleAllSelected,
} from "../../../../redux/slices/activityTypes";

//will render activity types of selected activity category.
export default function Activitytypes({ }) {
  const dispatch = useDispatch();
  const { activityTypes, isAllSelected } = useSelector(
    (state) => state.activityTypes
  );
  const { categories, selectedCategoryName } = useSelector((state) => state.activityCategories);
  const navigationPrevRef = useRef(null);
  const navigationNextRef = useRef(null);

  //activity category which is selected
  const selectedCategory = categories.find(
    (category) => category.isSelected === true
  );

  const currentActivityTypes = activityTypes.filter(
    (activityType) => activityType.activity_category_id === selectedCategory.id
  );

  const getSelectedTypesLength = () => {
    let len = 0;
    currentActivityTypes.map((type) => {
      if (type.isSelected) {
        len += 1;
      }
    });
    return len;
  };

  useEffect(() => {
    if (activityTypes.length === 0) return;
    const len = getSelectedTypesLength();
    if (len < currentActivityTypes.length) {
      dispatch(toggleAllSelected(false));
    } else {
      dispatch(toggleAllSelected(true));
    }
  }, [activityTypes]);

  const handleClick = () => {
    dispatch(toggleAllSelected(!isAllSelected));
    if (isAllSelected === false) {
      dispatch(selectAllActivityTypes());
    } else {
      dispatch(deselectAllActivityTypes());
    }
  };

  return (
    <div className="sidebar_extension__activity_types">
      <Swiper
        className="activity_types__slider"
        slidesPerView="auto"
        slidesPerGroup={2}
        mousewheel={true}
        navigation={{
          prevEl: navigationPrevRef.current,
          nextEl: navigationNextRef.current,
        }}
        onBeforeInit={(swiper) => {
          swiper.params.navigation.prevEl = navigationPrevRef.current;
          swiper.params.navigation.nextEl = navigationNextRef.current;
        }}
        modules={[Mousewheel, Navigation]}
      >
        <SwiperSlide>
          <div
            className={isAllSelected ? "activity_type active" : "activity_type"}
            onClick={handleClick}
          >
            <p className="activity_type__name"> All </p>
          </div>
        </SwiperSlide>
        {activityTypes.map((activityType) =>
          selectedCategoryName === 'Video Activity'  ? 
            <SwiperSlide key={activityType.id}>
              <ActivityType {...activityType} />
            </SwiperSlide> :
            activityType.activity_category_id === selectedCategory.id ? (
              <SwiperSlide key={activityType.id}>
                <ActivityType {...activityType} />
              </SwiperSlide>
            ) : null
        )}

        <div ref={navigationPrevRef} className="swiper__navigation_icon left">
          <img
            src="/assets/icons/left-icon.svg"
            style={{ cursor: "pointer" }}
          />
        </div>
        <div ref={navigationNextRef} className="swiper__navigation_icon right">
          <img
            src="/assets/icons/right-icon.svg"
            style={{ cursor: "pointer" }}
          />
        </div>
      </Swiper>
    </div>
  );
}
